export const footerMenu = function(){
  jQuery('.footer-item-wrapper .footer-item-heading').click(function () {
    jQuery(this).closest('.footer-item-wrapper').toggleClass('show');
  })
};
